import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const root = document.getElementById('altcheckout-root');

if (root) {
    createRoot(root).render(<App />);
}
